import store from 'store'
export const debug = store.get('debug') || {}
export const version = store.get('label:version') || '2'
export const ecsServer = process.env.VUE_APP_ECS_SERVER
export const decoderServer = process.env.VUE_APP_DECODER_SERVER
export const strApiServer = 'https://strapi.sihe6.com'
export const apiServer = process.env.VUE_APP_API_SERVER
export const clothAssessmentConfigUrl = strApiServer + '/clothassessmentconfigs'
export const defaultFrameRange = [0, 87]
export const labelTypes = {
  negative_default: {
    title: '负样本 默认',
    shape: 'rect',
    style: {
      default: {
        lineWidth: 3,
        fillStyle: 'rgba(0,0,255,0.0784)',
        strokeStyle: 'rgba(0,0,255,1)',
      },
      active: { lineWidth: 8 },
    },
  },
  negative_edge: {
    title: '负样本 布边',
    shape: 'rect',
    style: {
      default: {
        lineWidth: 3,
        fillStyle: 'rgba(0,128,0,0.0784)',
        strokeStyle: 'rgba(0,128,0,1)',
      },
      active: { lineWidth: 8 },
    },
  },
  negative_oil: {
    title: '负样本 油污',
    shape: 'rect',
    style: {
      default: {
        lineWidth: 3,
        fillStyle: 'rgba(0,128,0,0.0784)',
        strokeStyle: 'rgba(0,128,0,1)',
      },
      active: { lineWidth: 8 },
    },
  },
  negative_others: {
    title: '负样本 其他',
    shape: 'rect',
    style: {
      default: {
        lineWidth: 3,
        fillStyle: 'rgba(0,128,0,0.0784)',
        strokeStyle: 'rgba(0,128,0,1)',
      },
      active: { lineWidth: 8 },
    },
  },
  negative_seam: {
    title: '负样本 中缝',
    shape: 'rect',
    style: {
      default: {
        lineWidth: 3,
        fillStyle: 'rgba(0,128,0,0.0784)',
        strokeStyle: 'rgba(0,128,0,1)',
      },
      active: { lineWidth: 8 },
    },
  },
  negative_structure: {
    title: '负样本 结构件',
    shape: 'rect',
    style: {
      default: {
        lineWidth: 3,
        fillStyle: 'rgba(0,128,0,0.0784)',
        strokeStyle: 'rgba(0,128,0,1)',
      },
      active: { lineWidth: 8 },
    },
  },
  negative_thread: {
    title: '负样本 线毛',
    shape: 'rect',
    style: {
      default: {
        lineWidth: 3,
        fillStyle: 'rgba(0,128,0,0.0784)',
        strokeStyle: 'rgba(0,128,0,1)',
      },
      active: { lineWidth: 8 },
    },
  },
  positive_default: {
    title: '正样本 默认',
    shape: 'line',
    style: {
      default: { lineWidth: 3, strokeStyle: 'rgba(255,0,0,1)' },
      active: { lineWidth: 8 },
    },
  },
  positive_multiFrame: {
    title: '正样本 多帧',
    shape: 'line',
    style: {
      default: { lineWidth: 3, strokeStyle: 'rgba(255,140,0,1)' },
      active: { lineWidth: 8 },
    },
  },
  positive_seam: {
    title: '正样本 中缝',
    shape: 'rect',
    style: {
      default: {
        lineWidth: 3,
        fillStyle: 'rgba(255,140,0,0.0784)',
        strokeStyle: 'rgba(255,140,0,1)',
      },
      active: { lineWidth: 8 },
    },
  },
  positive_singleFrame: {
    title: '正样本 单帧',
    shape: 'line',
    style: {
      default: { lineWidth: 3, strokeStyle: 'rgba(255,140,0,1)' },
      active: { lineWidth: 8 },
    },
  },
  positive_crack: {
    title: '正样本 开裂',
    shape: 'rect',
    style: {
      default: {
        lineWidth: 3,
        fillStyle: 'rgba(255,140,0,0.0784)',
        strokeStyle: 'rgba(255,140,0,1)',
      },
      active: { lineWidth: 8 },
    },
  },
  positive_horizontal: {
    title: '正样本 横向',
    shape: 'line',
    style: {
      default: { lineWidth: 3, strokeStyle: 'rgba(38,230,0,1)' },
      active: { lineWidth: 8 },
    },
  },
}
export const labelTypesWebGL = {
  negative_default: {
    title: '负样本 默认',
    shape: 'rect',
    style: {
      default: {
        lineWidth: 3,
        fillStyle: [0x0000ff, 0.0784],
        strokeStyle: [0x0000ff, 1],
      },
      active: { lineWidth: 8 },
    },
  },
  negative_edge: {
    title: '负样本 布边',
    shape: 'rect',
    style: {
      default: {
        lineWidth: 3,
        fillStyle: [0x008000, 0.0784],
        strokeStyle: [0x008000, 1],
      },
      active: { lineWidth: 8 },
    },
  },
  negative_oil: {
    title: '负样本 油污',
    shape: 'rect',
    style: {
      default: {
        lineWidth: 3,
        fillStyle: [0x008000, 0.0784],
        strokeStyle: [0x008000, 1],
      },
      active: { lineWidth: 8 },
    },
  },
  negative_others: {
    title: '负样本 其他',
    shape: 'rect',
    style: {
      default: {
        lineWidth: 3,
        fillStyle: [0x008000, 0.0784],
        strokeStyle: [0x008000, 1],
      },
      active: { lineWidth: 8 },
    },
  },
  negative_seam: {
    title: '负样本 中缝',
    shape: 'rect',
    style: {
      default: {
        lineWidth: 3,
        fillStyle: [0x008000, 0.0784],
        strokeStyle: [0x008000, 1],
      },
      active: { lineWidth: 8 },
    },
  },
  negative_structure: {
    title: '负样本 结构件',
    shape: 'rect',
    style: {
      default: {
        lineWidth: 3,
        fillStyle: [0x008000, 0.0784],
        strokeStyle: [0x008000, 1],
      },
      active: { lineWidth: 8 },
    },
  },
  negative_thread: {
    title: '负样本 线毛',
    shape: 'rect',
    style: {
      default: {
        lineWidth: 3,
        fillStyle: [0x008000, 0.0784],
        strokeStyle: [0x008000, 1],
      },
      active: { lineWidth: 8 },
    },
  },
  positive_default: {
    title: '正样本 默认',
    shape: 'line',
    style: {
      default: {
        lineWidth: 3,
        strokeStyle: [0xff0000, 1],
      },
      active: { lineWidth: 8 },
    },
  },
  positive_multiFrame: {
    title: '正样本 多帧',
    shape: 'line',
    style: {
      default: {
        lineWidth: 3,
        strokeStyle: [0xff8c00, 1],
      },
      active: { lineWidth: 8 },
    },
  },
  positive_seam: {
    title: '正样本 中缝',
    shape: 'rect',
    style: {
      default: {
        lineWidth: 3,
        fillStyle: [0xff8c00, 0.0784],
        strokeStyle: [0xff8c00, 1],
      },
      active: { lineWidth: 8 },
    },
  },
  positive_singleFrame: {
    title: '正样本 单帧',
    shape: 'line',
    style: {
      default: {
        lineWidth: 3,
        strokeStyle: [0xff8c00, 1],
      },
      active: { lineWidth: 8 },
    },
  },
  positive_crack: {
    title: '正样本 开裂',
    shape: 'rect',
    style: {
      default: {
        lineWidth: 3,
        fillStyle: [0xff8c00, 0.0784],
        strokeStyle: [0xff8c00, 1],
      },
      active: { lineWidth: 8 },
    },
  },
  positive_horizontal: {
    title: '正样本 横向',
    shape: 'line',
    style: {
      default: { lineWidth: 3, strokeStyle: [0x26e600, 1] },
      active: { lineWidth: 8 },
    },
  },
}
export const clothAssessmentConfig = {
  availableForMultiFrame: {
    type: 'select',
    title: '多帧可用',
    options: ['是', '否'],
    required: true,
  },
  brightness: {
    type: 'select',
    title: '亮度',
    options: ['正常', '偏亮', '偏暗'],
    required: true,
    default: '正常',
  },
  brokenStringClarity: {
    type: 'select',
    title: '断线明显程度',
    options: ['无断线', '清晰', '一般', '较淡', '看不清'],
    required: true,
  },
  brokenStringThickness: {
    type: 'select',
    title: '断线粗细程度',
    options: ['非断线', '正常', '很细', '很粗'],
    required: true,
  },
  cameraDirty: {
    type: 'select',
    title: '摄像头脏污',
    options: ['是', '否'],
    required: true,
    default: '否',
  },
  cameraVeil: {
    type: 'select',
    title: '摄像头遮挡',
    options: ['是', '否'],
    required: true,
    default: '否',
  },
  clothCategory: {
    type: 'input-select',
    title: '布的品种',
    options: [
      '普通布',
      '无光绒加灯',
      '透布',
      '无光绒',
      '布面微透',
      '条绒4空8',
      '导电丝小菱形格',
      '7空7网布',
      '丝光绒',
      '四梳银丝宽条绒',
      '四梳银丝布',
      '抽条5空10',
      '条绒6空11',
      '透布加灯',
      '银丝不倒绒',
      '黑布',
      '底侧光',
      '抽条2空2',
      '2空2网布',
      '四梳网眼布',
      '两梳有光纤绒',
      '5空1网布',
      '抽条7空7',
      '阳细直条2空1',
      '三梳鱼鳞布',
      '大方块',
      '黑丝',
      '菠萝纹',
      '泡泡布',
      '黑丝小菱形格',
      '单丝布',
      '条绒5空10',
      '23空14针条绒斜粒绒',
      '4*2小方格',
      '蛇皮布',
      '四梳大网眼布',
      '方格超柔',
      '条绒20空17',
      '弹丝仿羊绒',
      '3空7网布',
      '条绒4空4',
      '长方格4空4',
      '菠萝格6空6',
    ],
    required: true,
    default: '普通布',
  },
  clothEdgeKind: {
    type: 'select',
    title: '布边信息',
    options: ['不包含布边', '包含布边'],
    required: true,
    default: '不包含布边',
  },
  clothTexture: {
    type: 'select',
    title: '布面纹理',
    options: ['普通', '纹理重'],
    required: true,
    default: '普通',
  },
  dataOrigin: {
    type: 'select',
    title: '数据来源',
    options: ['漏报', '误报', '正常报', '录负样本', '采数据', '多帧采数据'],
    required: true,
  },
  falseAlertKind: {
    type: 'select',
    title: '误报类型',
    required: true,
    options: [
      '非误报',
      '线毛',
      '纹理',
      '单条油污',
      '大片油污',
      '紧丝',
      '擦针',
      '短瑕疵',
      '特别像断线',
      '布后背景透过来',
      '防震板误报',
      '其他',
    ],
    default: '非误报',
  },
  jitterDegree: {
    type: 'select',
    title: '抖动程度',
    options: ['不抖动', '轻微抖动', '非常抖'],
    required: true,
    default: '不抖动',
  },
  middleGapKind: {
    type: 'select',
    title: '中缝类型',
    options: ['含像断线中缝', '含不像断线中缝', '无'],
    required: true,
    default: '无',
  },
}
export const videoBitRate = [
  {
    label: '20 mbps',
    bitRate: 20,
  },
  {
    label: '40 mbps',
    bitRate: 40,
  },
  {
    label: '80 mbps',
    bitRate: 80,
  },
  {
    label: '160 mbps',
    bitRate: 160,
  },
]
export const defaultVideoBitRate = 20

export default {
  debug,
  version,
  ecsServer,
  apiServer,
  clothAssessmentConfigUrl,
  defaultFrameRange,
  labelTypes,
  labelTypesWebGL,
  clothAssessmentConfig,
  videoBitRate,
  defaultVideoBitRate,
}
